import { getSignedParams, getPhpNow, getUdid, getUrlParams } from '@/utils';
import {
  getWxPayUrl,
  getConfig,
  init,
  login,
  loginMobile,
  guestLogin,
  autoLogin,
  phoneRegister,
  bindPhone,
  forgetPassword,
  role,
  certification,
  accountRegister
} from '@/api/channelServer';
import { channelServerConfig } from '@/config';
import server from './index';
import mixServer from './mixServer';
import cookies from '@/cookies';
import { Dialog } from 'vant';
import store from '../store';
import statis from './statis';

const channelServer = {
  // 配置接口返回结果
  configData: {},
  // 初始化返回结果
  initData: {},
  force_cert_status: '',
  // SDK的秘钥
  app_key: '',
  // access_token
  access_token: '',
  // uid
  ln_uid: '',
  accountStorage: [],
  code: getUrlParams('code') || '',
  getWxPayUrl(params) {
    return new Promise(resolve => {
      getWxPayUrl(params).then(res => {
        resolve(res);
      });
    });
  },
  getConfig() {
    const params = {
      game_id: getUrlParams('game_id'),
      appid: mixServer.ln_appid,
      weixin_code: this.code,
      time: getPhpNow()
    };
    // console.log(params)
    const signedParams = getSignedParams(channelServerConfig.app_key, params);
    return getConfig(signedParams).then(res => {
      const { data = {} } = res;
      this.configData = data;
      const app_key = data.app_key || '';
      this.app_key = app_key;
      channelServerConfig.api_app_key = app_key;
      return res;
    });
  },
  init() {
    return new Promise((resolve, reject) => {
      // 获取浏览器唯一标识
      getUdid()
        .then(udid => {
          const params = {
            appid: mixServer.ln_appid,
            time: getPhpNow(),
            ver: server.ver,
            udid: udid,
            uuid: udid,
            ...server.shareParams
          };
          // console.log(params)
          const signedParams = getSignedParams(this.app_key, params);
          init(signedParams)
            .then(res => {
              const { data = {} } = res;
              this.initData = data;
              const access_token = data.access_token || '';
              this.access_token = access_token;
              channelServerConfig.access_token = access_token;
              store.commit('SET_PROURL', data.protocal_url && data.protocal_url.replace('http', 'https'));
              store.commit('SET_SHOWBIND', data.is_bind);
              store.commit('SET_INITBIND', data.is_bind);
              resolve(res);
            })
            .catch(error => {
              console.error('SDK初始化失败:', error);
              reject(error);
            });
        })
        .catch(error => {
          console.error('获取浏览器唯一标识错误:', error);
          reject(error);
        });
    });
  },
  // 渠道登录
  login(params) {
    return new Promise((resolve, reject) => {
      login(params).then(({ ret, msg, data = {} }) => {
        if (ret == 0) {
          const passwd = atob(data.passwd || '');
          this.ln_uid = data.uid; // 用在红包参数
          // token存到cookie(为了绑定账号的时候使用，区分于游客token)
          cookies.setItem('ln_h5sdk_user_token', data.token, 3600 * 24 * 30);
          cookies.setItem('ln_h5sdk_user_name', data.account, 3600 * 24 * 30);
          // 用户账密数据存到store
          store.commit('SET_USER', { ...data, passwd });
          // console.log(data);
          // 保存登录返回数据
          const guestData = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd: data.passwd
            })
          };
          store.commit('SET_GUEST_DATA', guestData);

          try {
            if (store.state.isGdtSwitch) {
              if (data.is_reg == 1) {
                window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['REGISTER', JSON.stringify({method: 'account'})]});
              }
              window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['LOGIN', JSON.stringify({method: 'account'})]});
            }
          } catch (error) {
            console.log(error)
          }

          // 统计sdk渠道登录上报
          let statisLoginParams = {
            ln_uid: data.uid,
            uname: data.username,
            is_reg: data.is_reg,
            reg_time: parseInt(data.reg_time) || Math.floor(Date.now() / 1000),
            account_type: data.account_type
          };
          statis.lnsdkLogin([statisLoginParams]);

          this.isAntiAddiction = data.is_anti_addiction;
           
          //  判断是否绑定手机
          if (data.is_bind == 0 && store.state.show_bind == 1) {
            store.commit('SHOW', {
              name: 'BindPhone',
              params: data
            });
            if (mixServer.isAntiAddiction == 1) {
              if (data.force_cert_status == 0) {
                store.commit('SET_ISCERTNAME', false);
              }
            }
            return;
          }

          // 新用户注册账号并成功登录后（或者首次游客登录后），不弹出实名制弹窗(9.28需求)
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
              // 当current_time 大于 expire_time时，该实名窗口不可关闭，否则可关闭
              // 2021.12.9个人信息法实名填写前先声明弹窗
              store.commit('SHOW', {
                name: 'CertFront',
                params: { cert_url: data.real_name_cert, cert_msg: data.cert_msg }
              });
              store.commit('SET_ISCERTNAME', false);
              return
              // store.commit('SHOW', {
              //   name: 'Certification',
              //   params: { cert_msg: data.cert_msg, is_close: false }
              // })
            } else {
              let accStorage = localStorage.getItem('firloginarr') || [];
              if (!accStorage.includes(data.account)) {
                this.accountStorage.push(data.account);
                localStorage.setItem('firloginarr', JSON.stringify(this.accountStorage));
                Dialog({ message: '您的实名信息已存在于本平台的账号实名库，可正常登录游戏进行体验' });
              }
              store.commit('CLOSE');
              localStorage.setItem('agreeProt', true);
              store.commit('SET_ISCERTNAME', true);
            }
          } else {
            store.commit('CLOSE');
            localStorage.setItem('agreeProt', true);
          }
          const params = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd
            })
          };
          localStorage.setItem('login_type', 'account')
          resolve(params);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 手机验证码登录
  loginMobile(params) {
    return new Promise((resolve, reject) => {
      loginMobile(params).then(({ ret, msg, data = {} }) => {
        if (ret == 0) {
          const passwd = atob(data.passwd || '');
          this.ln_uid = data.uid; // 用在红包参数
          // token存到cookie(为了绑定账号的时候使用，区分于游客token)
          cookies.setItem('ln_h5sdk_user_token', data.token, 3600 * 24 * 30);
          cookies.setItem('ln_h5sdk_user_name', data.account, 3600 * 24 * 30);
          // 用户账密数据存到store
          store.commit('SET_USER', { ...data, passwd });
          const params = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd
            })
          };
          store.commit('SET_GUEST_DATA', params);
          this.isAntiAddiction = data.is_anti_addiction;
          // 新用户注册账号并成功登录后（或者首次游客登录后），不弹出实名制弹窗(9.28需求)
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
               // 当current_time 大于 expire_time时，该实名窗口不可关闭，否则可关闭
               // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert,  cert_msg: data.cert_msg}
                })
                store.commit('SET_ISCERTNAME', false);
                return
                // store.commit('SHOW', {
                //   name: 'Certification',
                //   params: { cert_msg: data.cert_msg, is_close: false }
                // })
            } else {
              let accStorage = localStorage.getItem('firloginarr') || [];
              if (!accStorage.includes(data.account)) {
                this.accountStorage.push(data.account);
                localStorage.setItem('firloginarr', JSON.stringify(this.accountStorage));
                Dialog({ message: '您的实名信息已存在于本平台的账号实名库，可正常登录游戏进行体验' });
              }
              store.commit('CLOSE');
              localStorage.setItem('agreeProt', true);
              store.commit('SET_ISCERTNAME', true);
            }
          } else {
            store.commit('CLOSE');
            localStorage.setItem('agreeProt', true);
          }
          localStorage.setItem('phone', store.state.userPhone)
          localStorage.setItem('login_type', 'phone')
          resolve(params);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 游客登录
  guestLogin() {
    return new Promise((resolve, reject) => {
      const token = cookies.getItem('ln_h5sdk_guest_token');
      // if (token) {
      //   // 本地有TOKEN,直接登录
      //   this.autoLogin({ token });
      //   return;
      // }
      // 没有TOKEN，走登录接口
      guestLogin({ encrypt_pwd: 1 }).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // token存到cookie
          cookies.setItem('ln_h5sdk_user_token', data.token, 3600 * 24 * 30);
          this.ln_uid = data.uid;
          // 统计sdk渠道登录上报
          let statisLoginParams = {
            ln_uid: data.uid,
            uname: data.username,
            is_reg: data.is_reg,
            reg_time: parseInt(data.reg_time) || Math.floor(Date.now() / 1000),
            account_type: data.account_type
          };
          statis.lnsdkLogin([statisLoginParams]);

          store.commit('SET_GUESTINFO', {
            guestAccount: data.account,
            guestPass: atob(data.passwd || ''),
            is_reg: data.is_reg
          });
          try {
            if (store.state.isGdtSwitch) {
              if (data.is_reg == 1) {
                // gdt('track', 'REGISTER')
                window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['REGISTER', JSON.stringify({method: 'guest'})]});
              } 
              window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['LOGIN', JSON.stringify({method: 'guest'})]});
            }
          } catch (error) {
            console.log(error)
          }
          // 保存登录返回数据
          const guestData = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd: data.passwd
            })
          };
          store.commit('SET_GUEST_DATA', guestData);
          console.log(guestData, '游客登录后的数据');
          localStorage.setItem('lnUserAccount', data.account);
          localStorage.setItem('lnUserPass', '******');
          if (data.is_reg == 1 && !localStorage.getItem('savewordPop')) {
            store.commit('SHOW', 'SavePassword');
            localStorage.setItem('savewordPop', true);
          }
          console.log('游客注册了', data.is_reg, store.state.isCloseSvPwd)
          // 先关闭保存密码窗口才进行后续操作
          if (data.is_reg == 1 && !store.state.isCloseSvPwd) {
            return;
          }
          console.log(data.is_bind, store.state.show_bind, '绑定状态6666');
          //  判断是否绑定手机
          if (data.is_bind == 0 && store.state.show_bind == 1) {
            store.commit('SHOW', {
              name: 'BindPhone',
              params: data
            });
            if (mixServer.isAntiAddiction == 1) {
              if (data.force_cert_status == 0) {
                store.commit('SET_ISCERTNAME', false);
              }
            }
            resolve(data);
            return;
          }
          // this.autoLogin({ token: data.token });
          // 判断游客登录是否是否实名，若没实名就弹出实名弹窗,否则关闭弹窗
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
              if (data.current_time >= data.expire_time) {
                // 当current_time 大于等于 expire_time时，该实名窗口不可关闭，否则可关闭
                // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert, cert_msg: data.cert_msg }
                });
                store.commit('SET_ISCERTNAME', false);
              } else {
                store.commit('SET_ISCERTNAME', true);
              }
            } else {
              // store.commit('CLOSE');
              store.commit('SET_ISCERTNAME', true);
            }
          } else {
            store.commit('SET_ISCERTNAME', true);
            // store.commit('CLOSE');
          }
          resolve(data);
        } else {
          resolve(ret);
          Dialog({ message: msg });
        }
      });
    });
  },
  // 自动登录
  autoLogin(params) {
    return new Promise((resolve, reject) => {
      autoLogin(params).then(({ ret, msg, data }) => {
        // 用户账密数据存到store
        const passwd = atob(data.passwd || '');
        if (data.is_guest == 1) {
          // data.passwd = '******';
        }
        store.commit('SET_USER', { ...data });
        if (ret == 0) {
          try {
            if (store.state.isGdtSwitch) {
              if (data.is_reg == 1) {
                // gdt('track', 'REGISTER')
                window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['REGISTER', JSON.stringify({method: 'auto'})]});
              } 
              window.webkit.messageHandlers['gdtReport'].postMessage({ params: ['LOGIN', JSON.stringify({method: 'auto'})]});
            }
          } catch (error) {
            console.log(error)
          }
          const params = {
            version: '1.0',
            ver: server.ver,
            network: '',
            info: JSON.stringify({
              ...data,
              passwd
            })
          };
          // 保存登录数据
          store.commit('SET_GUEST_DATA', params);
          localStorage.setItem('login_type', 'account')
          cookies.setItem('ln_h5sdk_user_token', data.token, 3600 * 24 * 30);
          // 统计sdk渠道登录上报
          let statisLoginParams = {
            ln_uid: data.uid,
            uname: data.username,
            is_reg: data.is_reg,
            reg_time: parseInt(data.reg_time) || Math.floor(Date.now() / 1000),
            account_type: data.account_type
          };
          statis.lnsdkLogin([statisLoginParams]);

          console.log(store.state.show_bind);
          //  判断是否绑定手机
          if (data.is_bind == 0 && store.state.show_bind == 1) {
            store.commit('SHOW', {
              name: 'BindPhone',
              params: data
            });
            if (mixServer.isAntiAddiction == 1) {
              if (data.force_cert_status == 0) {
                store.commit('SET_ISCERTNAME', false);
              }
            }
            resolve(data);
            return;
          }

          this.ln_uid = data.uid;
          // 判断游客登录是否是否实名，若没实名就关闭弹出实名弹窗,否则关闭弹窗
          if (mixServer.isAntiAddiction == 1) {
            if (data.force_cert_status == 0) {
              if (data.current_time >= data.expire_time) {
                // 当current_time 大于等于 expire_time时，该实名窗口不可关闭，否则可关闭
                // 2021.12.9个人信息法实名填写前先声明弹窗
                store.commit('SHOW', {
                  name: 'CertFront',
                  params: { cert_url: data.real_name_cert, cert_msg: data.cert_msg }
                });
                store.commit('SET_ISCERTNAME', false);
              } else {
                store.commit('SET_ISCERTNAME', true);
                if (store.state.componentName != 'SavePassword') {
                  store.commit('CLOSE');
                }
                resolve(mixServer.login(params));
              }
            } else {
              store.commit('SET_ISCERTNAME', true);
              if (store.state.componentName != 'SavePassword') {
                store.commit('CLOSE');
              }
              console.log(data.passwd)
              store.commit('SET_USER_INFO', {
                name: data.account,
                pwd: localStorage.getItem('lnUserPass') || atob(data.passwd)
              });
              resolve(mixServer.login(params));
            }
          } else {
            resolve(mixServer.login(params));
            if (store.state.componentName != 'SavePassword') {
              store.commit('CLOSE');
            }
            store.commit('SET_USER_INFO', {
              name: data.account,
              pwd: localStorage.getItem('lnUserPass') || atob(data.passwd)
            });
          }
          // 自动登录后调用融合登录
          // const mixLogin = mixServer.login(params);
          // resolve(mixServer.login(params));
        } else {
          if (ret == '71036') {
            store.commit('SET_CHANGEBIND', true)
            store.commit('SHOW', 'Login')
          }
          if (ret == '71019') {
            store.commit('SET_CHANGEBIND', true)
            store.commit('SHOW', 'Login')
          }
          Dialog({ message: msg });
        }
      });
    });
  },
  // 手机注册
  phoneRegister(params) {
    return new Promise((resolve, reject) => {
      phoneRegister(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve({ ret, msg, data });
        } else {
          // 注册失败
          Dialog({ message: msg });
        }
      });
    });
  },
  // 账号注册
  accountRegister(params) {
    return new Promise((resolve, reject) => {
      accountRegister(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve({ ret, msg, data });
        } else {
          // 注册失败
          Dialog({ message: msg });
        }
      });
    });
  },
  // 绑定手机
  bindPhone(params) {
    return new Promise((resolve, reject) => {
      bindPhone(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 忘记密码
  forgetPassword(params) {
    return new Promise((resolve, reject) => {
      forgetPassword(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          resolve(data);
        } else {
          Dialog({ message: msg });
        }
      });
    });
  },
  // 角色上报
  role(params) {
    return new Promise((resolve, reject) => {
      role(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 角色上报成功,不需反馈给游戏端
          resolve(data);
        } else {
          console.error('角色上报失败:' + msg);
        }
      });
    });
  },
  // 实名认证
  certification(params) {
    return new Promise((resolve, reject) => {
      certification(params).then(({ ret, msg, data }) => {
        if (ret == 0) {
          // 实名认证成功,不需反馈给游戏端
          resolve({ ret, msg, data });
        } else {
          Dialog({ message: msg });
        }
      });
    });
  }
};

export default channelServer;
